import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { User } from '@models/user';

import { correctHeight } from '@app/app.helpers';
import { AuthService, UserChangeEvent } from '@app/services/auth.service';
import { CommonService } from '@app/services/common.service';
import { ModulePathConstant } from '@app/constants/modulePath.constant';

declare var jQuery: any;

export class MenuNode {
    label: string;
    iconClass: string;
    authority: string[];
    route: string;
    childs: MenuNode[];
}

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html'
})

export class NavigationComponent implements OnInit {

    currentUser: User;

    menuNodes = [{
        label: ModulePathConstant.HOME_MODULE,
        iconClass: 'fa fa-home',
        route: ModulePathConstant.HOME_PATH,
    },{
        label: ModulePathConstant.PRODUCT_CENTER_MODULE,
        iconClass: 'fa fa-briefcase',
        childs: [{
            label: ModulePathConstant.PRODUCT_MODULE,
            authority: ['PERM_PRODUCT_READ'],
            route: ModulePathConstant.PRODUCT_PATH,
        }],
    }, 
    {
        label: ModulePathConstant.TEMPLATE_CENTER_MODULE,
        iconClass: 'fa fa-briefcase',
        childs: [
            {
                label: ModulePathConstant.HTML_TEMPLATE,
                authority: ['PERM_HTML_TEMPLATE_UPDATE'],
                route: ModulePathConstant.HTML_TEMPLATE_PATH,
            },
            {
                label: ModulePathConstant.ONEPAGE_TEMPLATE,
                authority: ['PERM_ONEPAGE_TEMPLATE_READ','PERM_ONEPAGE_TEMPLATE_CREATE','PERM_ONEPAGE_TEMPLATE_UPDATE'],
                route: ModulePathConstant.ONEPAGE_TEMPLATE_PATH,
            },
            {
            label: ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG,
            authority: ['PERM_ONEPAGE_TEMPLATE_CONFIG_CREATE','PERM_ONEPAGE_TEMPLATE_CONFIG_UPDATE'],
            route: ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG_PATH,
        },
        {
            label: ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT,
            authority: ['PERM_DEPLOYMENT_READ'],
            route: ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH,
        }],
    }, {
        label: ModulePathConstant.ORDER_MODULE,
        iconClass: 'fa fa-briefcase',
        childs: [{
            label: ModulePathConstant.ORDER,
            authority: ['PERM_ORDER_READ'],
            route: ModulePathConstant.ORDER_PATH,
        },{
            label: ModulePathConstant.ORDER_REPORT,
            iconClass: 'fa fa-cog',
            authority: ['PERM_ORDER_REPORT_READ'],
            route: ModulePathConstant.ORDER_REPORT_PATH,
        }],
    },{
        label: ModulePathConstant.MERCHANT_USER_MODULE,
        iconClass: 'fa fa-user-circle',
        childs: [{
            label: ModulePathConstant.USER_MODULE,
            authority: ['PERM_MERCHANT_USER_CREATE','PERM_MERCHANT_USER_UPDATE'],
            route: ModulePathConstant.MERCHANT_USER_PATH,
        }
    ]
    },{
        label: ModulePathConstant.MERCHANT_SETTINGS_MODULE,
        iconClass: 'fa fa-user-circle',
        childs: [{
            label: ModulePathConstant.MERCHANT_SETTINGS_MODULE,
            authority: ['PERM_MERCHANT_SETTINGS_CREATE','PERM_MERCHANT_SETTINGS_UPDATE'],
            route: ModulePathConstant.MERCHANT_SETTINGS_PATH,
        }
    ]
    },{
        label: ModulePathConstant.SYSTEM_USER_MODULE,
        iconClass: 'fa fa-users',
        childs: [{
            label: ModulePathConstant.USER_MODULE,
            authority: ['PERM_SET_SUPERADMIN','PERM_USER_CREATE','PERM_USER_UPDATE'],
            route: ModulePathConstant.USER_PATH,
        },  {
            label: ModulePathConstant.ROLE_MODULE,
            authority: ['PERM_ROLE_READ','PERM_ROLE_CREATE','PERM_ROLE_UPDATE'],
            route: ModulePathConstant.ROLE_PATH,
        }
    ]
    },
    {
        label: ModulePathConstant.SYSTEM_MODULE,
        iconClass: 'fa fa-users',
        childs: [{
            label: ModulePathConstant.SETTING_MODULE,
            iconClass: 'fa fa-cog',
            authority: ['PERM_SYSTEM_SETTING_SETUP'],
            route: ModulePathConstant.SETTING_PATH,
        },  {
            label: ModulePathConstant.QRCODE_GENERATE_MODULE,
            authority: ['PERM_SYSTEM_SETTING_SETUP'],
            route: ModulePathConstant.QRCODE_GENERATOR_PATH,
        }
        ]
    }
    ]

    constructor(private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private commonService: CommonService) { }

    ngOnInit(): void {

        if (this.commonService.getCurrentUser()) {
            this.currentUser = this.commonService.getCurrentUser();
        }

        this.authService.onUserChange.subscribe((event: UserChangeEvent) => {
            if (event.type == 'login') {
                this.currentUser = event.user;
            } else {
                this.currentUser = null;
            }
            setTimeout(() => {
                correctHeight();
                jQuery('#side-menu').metisMenu();
            });
        });
    }

    ngAfterViewInit(): void {
        if (this.currentUser) {
            jQuery('#side-menu').metisMenu();
        }
    }

    isActiveRoute(routename: string, fullMatch: boolean = false): boolean {
        if (fullMatch) {
            return this.router.url === routename;
        } else {
            let url = this.router.url.split(";")[0];
            let urlParts = url.split("/");
            let routeParts = routename.split("/");
            for (let i = 0; i < routeParts.length; i++) {
                if (routeParts[i] != urlParts[i]) {
                    return false;
                }
            }
            return true;
        }
    }

    isActiveMenuNode(menuNode: MenuNode) {
        let a = this.router.getCurrentNavigation()
        if (menuNode.childs == null) {
            return this.isActiveRoute(menuNode.route);
        } else {
            return menuNode.childs.find(x => this.isActiveMenuNode(x)) != null;
        }
    }

    clickMenuNode(menuNode: MenuNode) {
        if (menuNode.route != null) {
            this.router.navigate([menuNode.route]);
        }
    }

    isAccessible(menuNode: MenuNode) {
        // return true;
        if (menuNode.childs == null) {
            return menuNode.authority == null || this.commonService.hasAuthority(menuNode.authority);
        } else {
            let permissions = [];
            menuNode.childs.forEach(x => permissions = permissions.concat(x.authority));
            return permissions.length == 0 || this.commonService.hasAuthority(permissions);
        }
    }

    logout(): void {
        this.authService.logout();
        this.router.navigate(['/login']);
        // window.location.reload();
    }
}

